module.exports = __webpack_public_path__ + "static/media/double_angle0.b15a7c11.svg";